module.exports = __webpack_public_path__ + "assets/img/pbtrade_banner_2.9324bb5a.png";